import React, { FC } from "react";

import { SwiperSlide } from "swiper/react";

import Box from "@mui/material/Box";

import styles from "./style";

import Carousel from "components/Carousel";
import Image from "components/Image";
import CarouselArrows from "components/Carousel/Arrows";

const config = {
  loop: true,
  centerInsufficientSlides: false,
  spaceBetween: 0,
  slidesPerView: 1,
  breakpoints: undefined,
};

interface ImageCarouselProps {
  name?: string;
  front: string;
  back: string;
  imageUnoptimized?: boolean;
  bgColor?: string | null;
}

const ImageCarousel: FC<ImageCarouselProps> = ({
  name,
  front,
  back,
  imageUnoptimized,
  bgColor,
}) => {
  return (
    <Box sx={styles.wrapper}>
      <Carousel config={config}>
        <SwiperSlide style={{ width: "auto" }}>
          <Image
            src={front}
            alt={name}
            width={540}
            height={630}
            bgColor={bgColor}
            imageUnoptimized={imageUnoptimized}
          />
        </SwiperSlide>
        <SwiperSlide style={{ width: "auto" }}>
          <Image
            src={back}
            alt={name}
            width={540}
            height={630}
            bgColor={bgColor}
            imageUnoptimized={imageUnoptimized}
          />
        </SwiperSlide>
        <Box>
          <CarouselArrows sx={{ mt: 1, pr: 1, mb: 1 }} />
        </Box>
      </Carousel>
    </Box>
  );
};

export default ImageCarousel;
